import { Globe, ShieldAlert } from 'lucide-react';
import { LibraryRiskOptin } from './LibraryRiskOptin';
import { libraryUploadRiskMessages } from './libraryUploadRisk.messages';

interface LibrarySourceUrlOptinProps {
  /** Current checkbox state, owned by the parent so it can reset on reopen. */
  accepted: boolean;
  onAcceptedChange: (accepted: boolean) => void;
  /** Confirms the opt-in. Only invokable once the checkbox is ticked. */
  onConfirm: () => void;
  /** Optional dismiss action; when omitted the cancel button is hidden. */
  onCancel?: () => void;
}

/**
 * Risk opt-in step for adding web sources (URLs) to the Evidence library
 * (EVI-1566). Thin wrapper around {@link LibraryRiskOptin} supplying the
 * web-source copy. Rendered inline inside the New Collection Sources tab, only
 * when the user has not previously accepted.
 */
export const LibrarySourceUrlOptin = ({
  accepted,
  onAcceptedChange,
  onConfirm,
  onCancel,
}: LibrarySourceUrlOptinProps) => (
  <LibraryRiskOptin
    intro={libraryUploadRiskMessages.urlIntro}
    bullets={[
      {
        icon: (
          <ShieldAlert size={20} className="mt-0.5 shrink-0 text-validation-warning" />
        ),
        message: libraryUploadRiskMessages.urlRiskResponsibility,
      },
      {
        icon: <Globe size={20} className="mt-0.5 shrink-0 text-validation-warning" />,
        message: libraryUploadRiskMessages.urlRiskPublicAccess,
      },
    ]}
    checkboxLabel={libraryUploadRiskMessages.acceptCheckboxLabel}
    confirmLabel={libraryUploadRiskMessages.acceptButton}
    cancelLabel={libraryUploadRiskMessages.cancelButton}
    checkboxId="library-source-url-risk-accept"
    confirmTestId="library-source-url-risk-accept-button"
    accepted={accepted}
    onAcceptedChange={onAcceptedChange}
    onConfirm={onConfirm}
    onCancel={onCancel}
  />
);
